import getThreadContentItemByThreadId from '@/lib/threads/getThreadContentItemByThreadId.js';
import getThreadsById from '@/lib/threads/getThreadsById.js';
import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';
import buildThreadContentShell from '@/redux/reducers/pieveReducer/buildThreadContentShell.js';

const ensureThreadContentItem = ({ state, threadId }) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return null;
  }

  const existingThreadContentItem = getThreadContentItemByThreadId(state?.threadContent, normalizedThreadId);
  const threadMeta = getThreadsById(state?.threads)?.[normalizedThreadId] || null;

  if (existingThreadContentItem) {
    return {
      threadContent: state?.threadContent,
      threadContentItem: existingThreadContentItem,
      threadMeta
    };
  }

  if (!threadMeta) {
    return null;
  }

  const nextThreadContentItem = buildThreadContentShell({
    thread: threadMeta,
    threadId: normalizedThreadId
  });
  const nextThreadContent = upsertThreadContentItem(state?.threadContent, nextThreadContentItem);

  return {
    threadContent: nextThreadContent,
    threadContentItem: getThreadContentItemByThreadId(nextThreadContent, normalizedThreadId) || nextThreadContentItem,
    threadMeta
  };
};

export default ensureThreadContentItem;
